import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Spinner,
  VStack,
  Text,
} from '@chakra-ui/react';

const LoadingDocumentos = ({ isOpen }) => {
  return (
    <Modal isOpen={isOpen} onClose={() => {}} isCentered>
      <ModalOverlay bg="blackAlpha.500" />
      <ModalContent bg="whiteAlpha.900" boxShadow="lg" borderRadius="xl">
        <ModalBody>
          <VStack spacing={4} py={6} px={4} align="center" justify="center">
            <Spinner size="xl" thickness="4px" color="blue.500" />
            <Text fontSize="lg" fontWeight="medium" textAlign="center">
              Aguarde enquanto buscamos as informações
            </Text>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default LoadingDocumentos;
